export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload
    const now = Math.floor(Date.now() / 1000); // Current time in seconds

    return payload.exp < now; // Check if token is expired
  } catch (e) {
    return true;
  }
}
